import React from 'react';

import './styles.css';

const PAID = 'Paid';
const PARTIALLY_PAID = 'Partially paid';
const NOT_PAID = 'Not paid';
const COMPLETED = 'Completed';
const CHARGE_AND_REFUND_PENDING = 'Charge and refund pending';
const CHARGE_PENDING = 'Charge payment pending';
const REFUND_PENDING = 'Refund pending';
const NO_STATUS = 'N/A';
const DEFAULT = 'Default style';

interface DepositSummaryStatusTagProps {
  status: string;
}

const STATUS_TO_COLOR_MAPPER = {
  [COMPLETED]: {
    backgroundColor: '#49CD35',
    textColor: '#FFFFFF'
  },
  [CHARGE_AND_REFUND_PENDING]: {
    backgroundColor: '#FFEB99',
    textColor: '#000000'
  },
  [CHARGE_PENDING]: {
    backgroundColor: '#FFEB99',
    textColor: '#000000'
  },
  [REFUND_PENDING]: {
    backgroundColor: '#FFEB99',
    textColor: '#000000'
  },
  [PAID]: {
    backgroundColor: '#49CD35',
    textColor: '#FFFFFF'
  },
  [PARTIALLY_PAID]: {
    backgroundColor: '#ffeb99',
    textColor: '#000000'
  },
  [NOT_PAID]: {
    backgroundColor: '#ffeb99',
    textColor: '#000000'
  },
  [NO_STATUS]: {
    backgroundColor: '#CAD4DF',
    textColor: '#4A5665'
  },
  [DEFAULT]: {
    backgroundColor: '#FFEB99',
    textColor: '#000000'
  }
};

const DepositSummaryStatusTag = ({status}: DepositSummaryStatusTagProps) => {
  const {backgroundColor, textColor} =
    STATUS_TO_COLOR_MAPPER[status] || STATUS_TO_COLOR_MAPPER[DEFAULT];

  return (
    <div
      className="DepositSummaryStatusTag colab-centered colab-bold"
      style={{
        backgroundColor,
        color: textColor
      }}>
      {status}
    </div>
  );
};

export default DepositSummaryStatusTag;
